'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var react = require('react');
var ErrorBoundaryContext = require('./ErrorBoundaryContext.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);

class ErrorBoundary extends react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty__default["default"](this, "context", void 0);
    _defineProperty__default["default"](this, "state", {
      hasError: false
    });
  }
  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI
    return {
      hasError: true
    };
  }
  componentDidCatch(error) {
    this.context.handleError(error);
  }
  render() {
    const {
      hasError
    } = this.state;
    const {
      children,
      errorContent
    } = this.props;
    return hasError ? errorContent : children;
  }
}
_defineProperty__default["default"](ErrorBoundary, "contextType", ErrorBoundaryContext.ErrorBoundaryContext);

exports.ErrorBoundaryProvider = ErrorBoundaryContext.ErrorBoundaryProvider;
exports["default"] = ErrorBoundary;
